module.exports = __webpack_public_path__ + "img/np_3d-animation_1640041_000000.e0030465.svg";